import i18n from "i18next";
import Backend from 'i18next-xhr-backend';

const locale = i18n
    .use(Backend)
    .init({
        backend: {
            loadPath: process.env.NODE_ENV !== 'production' ? '/locales/{{lng}}.json' : '/wp-content/plugins/wp-campaigns/locales/{{lng}}.json'
        },
        lng: "en_US",
        interpolation: {
            escapeValue: false
        }
    });

export default locale;
